// extracted by mini-css-extract-plugin
module.exports = {"invoiceAreaFooterCircle":"InvoiceAreaSidebar_invoiceAreaFooterCircle_2tYgG"};